import { Modal } from "reactstrap"
import { toast } from "react-toastify";
import ApiService from "../../services/apiService";
import React, { useState, useEffect } from "react";

const EOPD =({
    isOpen,
    onClose,
   valveName,
    container,
  }: {
    isOpen: boolean;
    onClose: () => void;
    valveName: string;
     style?: React.CSSProperties;
     container?: HTMLElement | null;
  })=>{



    const [PumpData, setpumpdata] = useState<any[]>([]);  
const getAllPumpingStations = async () => {
  try {
    const response = await ApiService.axiosApi(`/tags`, {
      method: 'GET'
    });

    if (response.success) {
       
    
      setpumpdata(response.data); 
     
    } else {
      console.error('Failed to fetch pumping stations');
    }

  } catch (error) {
    console.error('Error fetching pumping stations:', error);
    console.error('Error fetching pumping stations');
  }
};

useEffect(() => {
  getAllPumpingStations();

  // Move setInterval inside useEffect
  const interval = setInterval(() => {
    getAllPumpingStations();
  }, 5000); 

  // Cleanup interval on unmount
  return () => clearInterval(interval);
}, []); // keep dependency array




  const valveDisplayNames: { [key: string]: string } = {
  EOPD1: "EOPD1",
  EOPD2: "EOPD2",
  EOPD3: "EOPD3",
  EOPD4: "EOPD4",
  EOPD5: "EOPD5",
};

     
    return(


         <>
         <Modal isOpen={isOpen} size='md' centered  toggle={onClose}
      style={{
        zIndex: 9999, // High z-index
      }}
       container={container || document.body} // Use container prop or fallback to body
        
      modalClassName="custom-modal-class"
        backdropClassName="custom-backdrop-class"
        contentClassName="custom-content-class">
            <div className="panel-pump"style={{border: '2px solid white'}}>
    <div className="panel-header-pump"style={{color:'white'}}>
     {valveDisplayNames[valveName] || valveName}
     <button className="refreshButtonEOPD"onClick={getAllPumpingStations} style={{ cursor: 'pointer' }}>&#x21bb;</button>
      <button className="close-btn-pump" onClick={onClose}>&times;</button>
    </div>
    <div className="panel-subheader-pump"style={{color:'white'}}>SYSTEM IN WEB SCADA</div>

  

    <div className="status-section-pump">
      <div
  className="status-item-pump" style={{color:'white'}}>
  <span className="status-box-pump"
  style={{
    width: '27px',
    height: '23px',
    backgroundColor:
      PumpData.find(t => t.name === `${valveName}_OPN` && t.value === 'True')
        ? 'green'
        : 'grey',
  }}></span>
  100% OPEN
</div>

      <div className="status-item-pump" style={{color:'white'}}><span className="status-box-pump"
  style={{
     width: '27px',
    height: '23px',
    backgroundColor:
      PumpData.find(t => t.name === `${valveName}_RMT` && t.value === 'True')
        ? 'green'
        : 'grey',
  }}></span>BFV IN REMOTE MODE</div>
      <div className="status-item-pump"style={{color:'white'}}><span className="status-box-pump"
  style={{
     width: '27px',
    height: '23px',
    backgroundColor:
      PumpData.find(t => t.name === `${valveName}_CLS` && t.value === 'True')
        ? 'red'
        : 'grey',
  }}></span>100% CLOSE</div>
      <div className="status-item-pump"style={{color:'white'}}><span className="status-box-pump"
  style={{
     width: '27px',
    height: '23px',
    backgroundColor:
      PumpData.find(t => t.name === `${valveName}_RDY` && t.value === 'True')
        ? 'green'
        : 'grey',
  }}></span>READY</div>
      <div className="status-item-pump"style={{color:'white'}}><span className="status-box-pump"
  style={{
     width: '27px',
    height: '23px',
    backgroundColor:
      PumpData.find(t => t.name === `${valveName}_TRP` && t.value === 'True')
        ? 'yellow'
        : 'grey',
  }}></span>BFV MOTOR TRIP</div>
      <div className="status-item-pump"style={{color:'white'}}><span className="status-box-pump"
  style={{
     width: '27px',
    height: '23px',
    backgroundColor:
      PumpData.find(t => t.name === `${valveName}_HLTHY` && t.value === 'True')
        ? 'green'
        : 'grey',
  }}></span>HEALTHY</div>
      <div className="status-item-pump"style={{color:'white'}}><span className="status-box-pump"
  style={{
     width: '27px',
    height: '23px',
    backgroundColor:
      PumpData.find(t => t.name === `${valveName}_OPNFLT` && t.value === 'True')
        ? 'yellow'
        : 'grey',
  }}></span>OPEN FEEDBACK FAULT</div>


    <div className="status-item-pump"style={{color:'white'}}><span className="status-box-pump"
  style={{
     width: '27px',
    height: '23px',
    backgroundColor:
      PumpData.find(t => t.name === `${valveName}_ANYFLT` && t.value === 'True')
        ? 'yellow'
        : 'grey',
  }}></span>ANY FAULT</div>

<div className="status-item-pump"style={{color:'white'}}><span className="status-box-pump"
  style={{
     width: '27px',
    height: '23px',
    backgroundColor:
      PumpData.find(t => t.name === `${valveName}_CLSFLT` && t.value === 'True')
        ? 'yellow'
        : 'grey',
  }}></span>CLOSE FEEDBACK FAULT</div>

    
    </div>

    <div className="control-section-pump">
      <div className="control-row-pump">
        <label style={{color:'white'}}>VALVE POSITION:</label>
         <label style={{background:'white'}}>
    {PumpData.find(t => t.tag === `${valveName}S`)?.value ?? 0}
  </label>
      </div>
      <div className="control-row-pump set-point-pump"style={{gap:'0px'}}>
        <label style={{color:'white'}}>SET POINT:</label>
      <label style={{background:'white'}}>{PumpData.find(t => t.tag === `${valveName}_SP`)?.value ?? 0}</label>
        
      </div>
    </div>
  </div>
  </Modal>
         </>
    )
}

export default EOPD;